<template>
  <div>
    <b-card title="Order List" class="mb-4">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>
          <label for="perPage" class="form-label">Per page</label>
          <b-form-select id="perPage" v-model="perPage" :options="perPageOptions" class="w-auto"></b-form-select>
        </div>
      </div>

      <!-- Order Table -->
      <b-table
        :items="orders"
        :fields="fields"
        responsive="sm"
        bordered
        :per-page="perPage"
        :current-page="currentPage"
      >
        <!-- Payment Status Slot -->
        <!-- <template #cell(paymentStatus)="data">
          <b-badge :variant="getPaymentStatusVariant(data.item.paymentStatus)">
            {{ data.item.paymentStatus }}
          </b-badge>
        </template> -->

        <!-- Order Status Slot -->
        <template #cell(orderStatus)="data">
  <b-form-select
    v-model="data.item.orderStatus"
    :options="orderStatusOptions"
    class="w-100"
    @change="updateOrderStatus(data.item)"
  ></b-form-select>
</template>
 <!-- Order Date Slot -->
 <template #cell(orderedAt)="data">
          {{ formatDate(data.item.orderedAt) }}
        </template>
        <!-- Action Slot -->
        <template #cell(action)="data">
          <b-button variant="success" size="sm" @click="viewOrder(data.item)">
            View Order
          </b-button>
          <b-button
            variant="success"
            size="sm"
            class="ml-2"
            @click="convertInvoice(data.item)"
          >
            Create Invoice
          </b-button>
        </template>
      </b-table>

      <!-- Pagination -->
      <div class="d-flex justify-content-between align-items-center mt-3">
        <div>
          Showing {{ firstItem }} to {{ lastItem }} of {{ totalEntries }} entries
        </div>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalEntries"
          :per-page="perPage"
          align="right"
          size="sm"
        ></b-pagination>
      </div>
    </b-card>

    <!-- Order Details Modal -->
    <b-modal id="orderModal" title="Order Details" hide-footer>
      <div v-if="selectedOrder">
        <b-list-group>
          <b-list-group-item
            v-for="item in selectedOrder.lines"
            :key="item.cartLineId"
            class="d-flex align-items-center"
          >
            <img :src="item.product.imageUrl" alt="Product Image" class="order-img" />
            <div class="ml-3">
              <h5>{{ item.product.productName }}</h5>
              <p>Price: Rs{{ item.product.price }}</p>
              <p>Quantity: {{ item.quantity }}</p>
            </div>
          </b-list-group-item>
        </b-list-group>
        <!-- Shipping Address Section -->
    <div class="mt-3">
      <h5>Shipping Address</h5>
      <p v-if="selectedOrder.shippingAddress">
        {{ selectedOrder.shippingAddress.line1 }}<br />
    <span v-if="selectedOrder.shippingAddress.line2">{{ selectedOrder.shippingAddress.line2 }}<br /></span>
    <span v-if="selectedOrder.shippingAddress.line3">{{ selectedOrder.shippingAddress.line3 }}<br /></span>
    {{ selectedOrder.shippingAddress.city }}
      </p>
      <p v-else>No shipping address available</p>
    </div>
      </div>
      <div v-else>
        <p>No order details available.</p>
      </div>
      <b-button variant="secondary" class="mt-3" @click="$bvModal.hide('orderModal')">
        Close
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import {
  BTable,
  BButton,
  BCard,
  BPagination,
  BFormSelect,
  BListGroup,
  BListGroupItem,
  BBadge,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    BTable,
    BButton,
    BCard,
    BPagination,
    BFormSelect,
    BListGroup,
    BListGroupItem,
    BBadge,
  },
  data() {
    return {
      fields: [
        { key: "name", label: "Customer Name", sortable: true },
        { key: "email", label: "Email", sortable: true },
        { key: "orderReference", label: "Order Reference", sortable: true },
        // { key: "paymentStatus", label: "Payment Status", sortable: true },
        { key: "orderStatus", label: "Order Status", sortable: true },
        { key: "orderedAt", label: "Order Date", sortable: true }, // Add order date field
        { key: "action", label: "Action", tdClass: 'd-flex align-items-center' },
      ],
      orderStatusOptions: [
      { value: 'Pending', text: 'Pending' },
      { value: 'OrderReceived', text: 'Order Received' },
      { value: 'OrderDelivery', text: 'Order Delivery' },
      { value: 'AwaitingPayment', text: 'Awaiting Payment' },
      { value: 'PaymentCompleted', text: 'Payment Completed' },
      { value: 'AwaitingDelivery', text: 'Awaiting Delivery' },
      { value: 'Delivered', text: 'Delivered' },
      { value: 'Cancelled', text: 'Cancelled' },
],
      orders: [], // Initialize as an empty array
      selectedOrder: null,
      perPageOptions: [5, 10, 15, 20],
      perPage: 5,
      currentPage: 1,
    };
  },
  computed: {
    ...mapGetters("exportModule", {
      orders: "ecom", // Ensure this matches the getter name in your Vuex store
      loadingEcommerce: "loading",
    }),

    totalEntries() {
      return this.orders?.length || 0; // Fallback to 0 if orders is undefined
    },
    firstItem() {
      return this.orders?.length ? (this.currentPage - 1) * this.perPage + 1 : 0;
    },
    lastItem() {
      const last = this.currentPage * this.perPage;
      return this.orders?.length ? Math.min(last, this.totalEntries) : 0;
    },
  },
  methods: {
    ...mapActions("ecommerceModule", [
      "getOrderListAction",
      "postCompleteOrderAction",
    ]),

    // View Order Details
    viewOrder(order) {
  this.selectedOrder = {
    ...order,
    shippingAddress: {
      line1: order.line1 || '',
      line2: order.line2 || '',
      line3: order.line3 || '',
      city: order.city || '',
    },
  };
  this.$bvModal.show("orderModal");
},

    // Redirect to Create Invoice Page
    convertInvoice(order) {
      this.$router.push({ path: "/invoice/add", query: { orderId: order.orderId } });
    },

    // Mark Order as Complete
    async updateOrderStatus(order) {
      let updatedStatus = (order.orderStatus || "").replace(/\s+/g, ''); 

try {
  this.$swal({
    title: "Updating...",
    text: `Setting status to ${updatedStatus}`,
    onOpen: () => this.$swal.showLoading(),
    showConfirmButton: false,
  });

  console.log("Updating orderId:", order.orderId);
  console.log("With status:", updatedStatus);

  await this.postCompleteOrderAction({
  orderId: order.orderId,
  status: updatedStatus
});


  this.$swal("Success", "Order status updated successfully!", "success");

  const updatedOrders = await this.getOrderListAction();
  this.orders = updatedOrders;
} catch (error) {
  console.error("Error updating order:", error);
  this.$swal("Error", "Failed to update the order status.", "error");
}

},

    // Get Payment Status Variant
    getPaymentStatusVariant(status) {
      switch (status) {
        case "Paid":
          return "success";
        case "Pending":
          return "warning";
        case "Failed":
          return "danger";
        default:
          return "secondary";
      }
    },

        // Format Date
        formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleString(); // Format as per user's locale
    },
  },
  async mounted() {
    await this.getOrderListAction()
      .then((response) => {
        console.log(response);
        this.orders = response;
        console.log("response", this.orders);
      })
      .catch((response) => {
        console.log(response);
      });
  },
};
</script>

<style scoped>
.d-flex {
  flex-wrap: wrap;
}

.order-img {
  width: 80px;
  height: 80px;
  border-radius: 8px;
  object-fit: cover;
}
</style>